import React from "react";
import { specialityData } from "../assets/assets_frontend/assets";
import { Link } from "react-router-dom";
const SpecialityMenu = () => {
  return (
    <div className="flex flex-col items-center mx-auto py-5 gap-4 ">
      <h1 className="font-medium text-3xl">speciality menu</h1>
      <p className="text-sm ">
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Obcaecati,
        non.
      </p>
      <div className="flex  flex-wrap justify-center  gap-4">
        {specialityData.map((ele, index) => (
          <Link
            className="hover:translate-y-[-10px] py-5 flex flex-col items-center transition-all duration-500 flex-shrink-0 "
            key={index}
            to={`/doctors/${ele.speciality}`}
          >
            <img src={ele.image} alt="2" />
            <p className="text-center">{ele.speciality}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SpecialityMenu;
